export default "__VITE_ASSET__d49269b0__"